<template>
  <span class="rcp-hit"><template v-if="parts.hit">{{ parts.before }}<mark>{{ parts.hit }}</mark>{{ parts.after }}</template><template v-else>{{ parts.before }}</template></span>
</template>

<script>
import { splitHit } from "../recipesLogic";

/**
 * Tekst sa istaknutim pogotkom pretrage (<mark>): pretraga ne razlikuje ćirilicu i latinicu ni kvačice,
 * a ističe se onaj dio teksta koji se vidi na ekranu.
 */
export default {
  name: "RecipeHit",
  props: {
    text: { type: String, default: "" },
    query: { type: String, default: "" },
  },
  computed: {
    parts() {
      return splitHit(this.text, this.query);
    },
  },
};
</script>
